import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService } from '../app/shared';

@Component({
  selector: 'app-page-not-found',
  template: require('./page-not-found.component.html'),
  styles: [require('./page-not-found.component.scss')]
})
export class PageNotFoundComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService) { }

  title = '404 - Page Not Found';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';

  ngAfterViewInit() {
      this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
  }
});
}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/page-not-found.component.ts